<template>
  <a-modal
      :visible="visible"
      @ok="ok"
      @cancel="cancel"
      okText='确定'
      cancelText='取消'
      destroyOnClose 
      :maskClosable="false"
      width="700px"
      class="modalStyle"
    >
      <template slot="title">
        <a-alert message="从工厂原料数据库中添加原料" banner />
      </template>
      <div class="justifyBox" style="margin-bottom: 10px;">
        <material-select @changeForm="changeForm" :url="url" placeholderStr="原料名称/代码" feild="keyword" />
        <type-cascader @changeForm="changeForm" feild="typeId" />
      </div>
      <a-table :scroll='{y: 260}' :columns="columns" :data-source="list" :row-selection="rowSelection" :pagination="pagination" rowKey="id">
        <span slot="sort" slot-scope="t,r,index">{{index + 1}}</span>
        <span slot="price" slot-scope="t,record">{{record[priceField]}}</span>
      </a-table>
      <template slot="footer">
        <p style="float: left;">
          已选中 <span class="colorRed">{{this.selectedRowKeys.length || 0}}</span> 个原料
        </p>
        <a-button @click="cancel">取消</a-button>
        <a-button @click="ok" type="primary" :loading="submitLoading">确定</a-button>
      </template>
  </a-modal>
</template>

<script>
import api from '../api';
import MaterialSelect from '../CommonConponents/MaterialSelect'
import TypeCascader from '../CommonConponents/TypeCascader.vue'
import { getRequest } from "@/components/Common/Utils/Utils";
export default {
  props: ['visible','type','rowData','customId'],
  components: {TypeCascader,MaterialSelect},
  data() {
    return {
      url: '/nhf-custom/custfactorystaffraw/pageWithOutSpecialTypeIdAndSelected',
      form: {},
      detailData: {},
      columns: [
        {
          title: '序号',
          dataIndex: 'sort',
          scopedSlots: { customRender: 'sort' },
          width: 60,
          ellipsis: true,
        },
        {
          title: '原料名称',
          dataIndex: 'name',
          ellipsis: true,
          width: 120
        },
        {
          title: '代码',
          dataIndex: 'code',
          width: 120,
          ellipsis: true,
        },
        {
          title: '类型',
          dataIndex: 'typeName',
          width: 120,
          ellipsis: true,
        },
      ],
      list: [],
      selectedRowKeys: [],
      selectedRows: [],
      pagination: {
        total:0,
        pageSize: 20,
        current: 1,
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current
          this.getList({current,pageSize})
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.current = 1
          this.pagination.pageSize = pageSize
          this.getList({current: 1,pageSize})
        } //每页多少条
      },
      submitLoading: false,
      maxLen: 20
    }
  },
  computed: {
    title() {
      return this.type === 'edit' ? '编辑' : '新增'
    },
    rowSelection(){
      return {
        onChange: (selectedRowKeys,selectedRows) => {
          this.selectedRowKeys = selectedRowKeys.splice(0,this.maxLen)
          let arr = [...this.selectedRows, ...selectedRows]
          this.selectedRows = selectedRowKeys.map(i => {
            return arr.filter(item=>item.id === i)[0]
          })
          this.list = [...this.list]
        },
        selectedRowKeys: this.selectedRowKeys,
        getCheckboxProps: record => ({
          props: {
            disabled: this.selectedRowKeys.length >= this.maxLen && !this.selectedRowKeys.includes(record.id)
          },
        }),
      }
    }
  },
  watch: {
    visible(val){
      if(val) {
        this.form = {}
        this.selectedRowKeys = []
        this.selectedRows = []
        this.pagination.current = 1
        this.pagination.pageSize = 20
        this.getList()
      }
    }
  },
  methods: {
    getList(pagination){
      let {current=1,pageSize=20} = pagination || this.pagination
      let factoryId = window.localStorage.getItem('factoryId')
      let params = {
        ...this.form,
        current,size:pageSize,factoryId,customId: getRequest('id')
      }
      this.$http.get(this.url,{params}).then(res => {
        let {success,data} = res;
        if(success){
          let {records,current=1,total=0} = data;
          this.pagination.current = current
          this.pagination.total = total
          this.list = records || []
        }else{
          this.$message.error('查询失败')
        }
      })
    },
    changeForm(data){
      this.form = {...this.form,...data}
      this.pagination.current = 1
      this.pagination.pageSize = 20
      this.getList()
    },
    async ok(){
      if(this.selectedRowKeys.length === 0){
        this.$message.error('请选择原料')
      }else{
        let params = {
          customId: this.customId,
          factoryId: window.localStorage.getItem('factoryId'),
          ids: this.selectedRowKeys.join(',')
        }
        this.submitLoading = true
        let res = await api.addCustomerMaterialRow(params)
        let {success,msg} = res || {}
        this.submitLoading = false
        this.$message[success ? 'success' : 'warning'](msg)
        this.$emit('close','addVisible',true)
      }
    },
    cancel(){
      this.$emit('close','addVisible')
    },
  }
}
</script>

<style lang="scss">
.modalStyle {
  .ant-modal-header {
    padding: 0;
    border-bottom: none;
  }
  .ant-modal-close-x {
    width: 36px;
    height: 36px;
    line-height: 36px;
  }
}
</style>